import { PopupStore } from '@/helpers/Popup'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import { disableBodyScroll } from '@/utils/dom'
import { makeAutoObservable } from 'mobx'

export class UISearchMktuClasses {
  popupSelectWords = new PopupStore({ needDisableScroll: false })
  popupListSelectedWords = new PopupStore({ needDisableScroll: false })
  popupSelectedMktuClasses = new PopupStore({ needDisableScroll: false })
  popupMktuClass = new PopupStore({ needDisableScroll: false })

  editableMktuClass: MktuClassStore | null = null

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  showSelectWordsPopup() {
    disableBodyScroll()
    this.popupSelectWords.show()
  }

  startEditMktuClass(mktuClass: MktuClassStore) {
    this.editableMktuClass = mktuClass
    this.popupMktuClass.show()
  }

  endEditMktuClass() {
    this.editableMktuClass = null
    this.popupMktuClass.hide()
  }

  reset() {
    this.popupSelectWords.hide()
    this.popupListSelectedWords.hide()
    this.popupSelectedMktuClasses.hide()
    this.popupMktuClass.hide()
    this.editableMktuClass = null
  }
}
